<template>
  <div class="horizontal-layout page-header-light horizontal-menu 1-column forgot-bg blank-page blank-page" data-open="click" data-menu="horizontal-menu" data-col="1-column">
    <div class="row">
      <div class="col s12">
        <div class="container">
          <div id="forgot-password" class="row">
            <div class="col s12 m6 l4 z-depth-4 offset-m4 card-panel border-radius-6 forgot-card bg-opacity-8">
              <form class="login-form">
                <div class="row">
                  <div class="input-field col s12">
                    <h5 class="ml-4">Reset Password</h5>
                    <!-- <p class="ml-4">You can reset your password</p> -->
                  </div>
                </div>
                <div class="row margin">
                  <div class="input-field col s12">
                    <!-- <i class="material-icons prefix pt-2">lock_outline</i> -->
                    <input maxlength="15" @keyup="errorMessage=''" v-model="password" id="new_password" name="new_password" type="password">
                    <label for="new_password">New Password</label>
                  </div>
                </div>
                <div class="row margin">
                  <div class="input-field col s12">
                    <!-- <i class="material-icons prefix pt-2">lock_outline</i> -->
                    <input maxlength="15" @keyup="errorMessage=''" id="confirm_password" name="confirm_password" type="password">
                    <label for="password">Confirm Password</label>
                  </div>
                </div>
                <div class="row">
                  <div class="input-field col s12">
                    <span class="error-message text-center" v-if="showErrMsg">{{errorMessage}}</span>
                    <button type="submit" @keyup="errorMessage=''" v-loader-button="isLoading" name="action" class="btn waves-effect waves-light gradient-45deg-purple-deep-orange col s12 mb-1">
                          Reset
                          Password
                        </button>
                  </div>
                </div>
                <div class="row">
                  <div class="input-field col s12 m12 l12">
                    <p class="margin medium-small right-align" @click="$router.push({path:'/login'})">
                      <a class="pointer">Back to Login ?</a>
                    </p>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        showErrMsg: false,
        isLoading: false,
        errorMessage: "",
        uid: "",
        token: "",
        password: "",
        clientId: ""
      };
    },
    created() {
      this.initJs();
      let temp = location.href;
      this.clientId = window.uuid();
      let validCheck = temp.split("/")[temp.split("/").length - 1];
      if (validCheck && validCheck == "reset-password") {
      } else {
        this.uid = temp.split("/")[temp.split("/").length - 2];
        this.token = temp.split("/")[temp.split("/").length - 1];
      }
    },
    methods: {
      initJs() {
        setTimeout(() => {
          $(() => {
            $(".login-form").validate({
              rules: {
                new_password: {
                  required: true,
                  minlength: 6
                },
                confirm_password: {
                  required: true,
                  minlength:6,
                  equalTo: "#new_password"
                }
              },
              //For custom messages
              messages: {
                new_password: {
                  minlength: "Please enter at least 6 characters"
                },
                confirm_password: {
                  minlength: "Please enter at least 6 characters",
                  equalTo: "Passwords does not match"
                }
              },
              errorElement: "div",
              errorPlacement: function(error, element) {
                var placement = $(element).data("error");
                if (placement) {
                  $(placement).append(error);
                } else {
                  error.insertAfter(element);
                }
              },
              submitHandler: e => {
                $('button').attr('disabled','disabled');
                setTimeout(() =>{
                  $('button').removeAttr('disabled');
                },500);
                setTimeout(() =>{
                  this.onResetPassword();
                },100);
                return false;
              }
            });
          });
        }, 500);
      },
      onResetPassword() {
        this.isLoading = true;
        let params = {
          uid: this.uid,
          token: this.token,
          password: this.password,
          uuid: this.clientId
        };
        this.showErrMsg = false;
        ajax.post(
          Constants.default.APIURL.ResetPassword,
          params,
          res => {
            this.isLoading = false;
            this.showErrMsg = false;
            let data = res.data.user;
            if (data != "") {
              let permissions = [];
              data.permissions.forEach(val =>{
                permissions.push(val.permission);
              });
              let userDetails = {
                email: data.email,
                id: data.id,
                first_name: data.first_name,
                short_name: data.short_name,
                mobile_number: data.mobile_number,
                access_token: res.data.auth_token,
                permissions : permissions,
                persona : data.persona
              };
              localStorage.removeItem('homecare_admin_auth');
              sessionStorage.removeItem('homecare_admin_auth');
              localStorage.setItem(
                "homecare_admin_auth",
                JSON.stringify(userDetails)
              );
              if(localStorage.getItem("homecare_admin_fcmtoken")){
                ajax.put(Constants.default.APIURL.UpdateFCMToken,{
                  firebase_token : localStorage.getItem("homecare_admin_fcmtoken")
                },
                res => {
                },
                err => {
                });
              }
              if(userDetails.persona == "superuser"){
                this.$router.push({
                  path: "/app/dashboard"
                });
              }else{
                this.$router.push({
                  path: "/app/dashboard"
                });
              }
            }
          },
          err => {
            this.showErrMsg = true;
            this.isLoading = false;
            if (err.data.non_field_errors) {
              this.errorMessage = err.data.non_field_errors[0];
            } else {
              if (Object.keys(err.data).length > 0) {
                this.errorMessage = err.data[Object.keys(err.data)[0]][0];
              }
            }
            this.errorMessage = this.errorMessage ?
              this.errorMessage :
              "Something went wrong.";
          }
        );
      }
    }
  };
</script>

<style lang="scss" scoped>
  .margin{
    margin-left: -2px !important;
  }
  @import "./../../public/assets/css/pages/forgot.css";
</style>
